import colors from './colors'

export default {
  primary: {
    main: colors.yellow,
  },
  secondary: {
    main: colors.greys.dark,
  },
  error: {
    main: colors.red,
  },
  info: {
    main: colors.blue,
  },
  warning: {
    main: colors.yellow,
  },
  success: {
    main: colors.green,
  },
  common: {
    black: colors.black,
    green: colors.green,
    yellow: colors.yellow,
    red: colors.red,
    blue: colors.blue,
    grey: colors.greys,
    white: colors.white,
  },
  grey: {
    ...colors.greys,
  },
  background: {
    paper: colors.greys.veryLight,
    default: colors.white,
  },
}
